class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const form = this.closest('form');
      if (!form) return;

      const input = form.querySelector('[name="id"]');
      if (!input) return;

      input.value = event.target.value;
    });
  }
}

customElements.define('variant-selects', VariantSelects);